var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.loading, expression: "loading" }], class: _vm.loadingClass }, [_c('img', { class: _vm.className, attrs: { "src": _vm.imgUrl, "alt": _vm.alt, "width": _vm.imgWidth, "height": _vm.imgHeight } })]);
};
var staticRenderFns = [];

export { render, staticRenderFns };